//
// VisualContainerElementController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./VisualElementController";
import "../../models/visualElements/VisualContainerElement";

var VisualContainerElementController = createModule("BIRD::VisualContainerElementController", ["BIRD::BIRDModelController","BIRD::RendererManagerController","BIRD::VisualElementController"], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        getModel: [1],
    },
    {
        _create: [4,1],
    },
    ,
]);
export default VisualContainerElementController;
